import React from 'react';
import { Count, Name, RankIcon, RankNum, Rate, Row, Thumb, ThumbImg } from './RankRow.styles';

export type RankTier = 'second' | 'third' | 'fourth';

export interface RankRowProps {
  /** 순위 (2,3,4 …) — 아이콘이 없을 때 숫자로 표기 */
  rank: number;
  name: string;
  ratePercent: number;
  voteCount: number;
  thumb: string | null;
  /** 메달/트로피 아이콘. 없으면 rank 숫자 표기 */
  icon: string | null;
  /** rate 배지 색상 분기 (§2-1) */
  tier: RankTier;
}

const numberFormatter = new Intl.NumberFormat('ko-KR');

/**
 * 랭킹 한 행 (entity) — 순위 아이콘/번호 + 썸네일 + 메뉴명 + 득표율 배지 + 득표수.
 * 출처: 스펙 §1-7. 좌표 하드코딩 금지 → 데이터 기반 행.
 */
export function RankRow({ rank, name, ratePercent, voteCount, thumb, icon, tier }: RankRowProps) {
  return (
    <Row $rank={rank} data-rank={rank}>
      <RankIcon>
        {icon ? (
          <img src={icon} alt={`${rank}위`} width="25" height="24" loading="lazy" />
        ) : (
          // 4위 등 아이콘 없는 행은 숫자 표기 (§1-7, 폰트는 표준 fallback 으로 통일 §9-3)
          <RankNum aria-label={`${rank}위`}>{rank}</RankNum>
        )}
      </RankIcon>

      <Thumb>{thumb ? <ThumbImg src={thumb} alt={`${name} 사진`} loading="lazy" /> : null}</Thumb>

      <Name>{name}</Name>

      <Rate $tier={tier}>{ratePercent}%</Rate>

      <Count>{numberFormatter.format(voteCount)} 득표</Count>
    </Row>
  );
}
